import React from "react";
import { button } from "../styles/commonStyles";

const StreakStatusModal = ({ status, setStatus, user, onRestore, canRestore }) => {
  if (!status) return null;

  const { type, previousStreak, currentStreak, freezesLeft, missedDays } = status;
  const isProtected = type === "protected";
  const isBroken = type === "broken";

  const restoreCost = (missedDays || 0) * 100;
  const canAffordRestore = canRestore && canRestore(user, missedDays);

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
        background: "rgba(15, 23, 42, 0.75)", backdropFilter: "blur(8px)",
        zIndex: 30000, display: "flex", alignItems: "center", justifyContent: "center",
        padding: "20px"
      }}
      onClick={() => setStatus(null)}
    >
      <div
        style={{
          background: "white", position: "relative",
          padding: "32px 20px 24px",
          width: "92%", maxWidth: "400px",
          textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
          borderRadius: "28px",
          animation: "streakPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={() => setStatus(null)}
          style={{
            position: "absolute", top: "20px", right: "20px",
            width: "32px", height: "32px", borderRadius: "50%",
            background: "#F1F5F9", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", fontSize: "16px", color: "#64748B"
          }}
        >
          ✕
        </button>

        {/* Mascot Slot */}
        <div className="mascot-slot" style={{ 
          width: "120px", height: "120px", 
          background: isProtected ? "#F0FDFB" : "#FFF7ED", 
          borderRadius: "30px", 
          marginBottom: "20px",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "60px"
        }}>
          {isProtected ? "❄️" : "💔"}
        </div>

        <h2 style={{ 
          margin: "0 0 8px", 
          fontSize: "28px", 
          color: "#0F172A", 
          fontWeight: "800" 
        }}>
          {isProtected ? "Streak Protected" : "Oh no... streak lost"}
        </h2>

        <p style={{ 
          margin: "0 0 24px", 
          color: "#64748B", 
          fontSize: "16px", 
          fontWeight: "600",
          lineHeight: "1.5"
        }}>
          {isProtected 
            ? `Your freeze saved your ${currentStreak}-day streak.` 
            : `${previousStreak} Day Streak → 0`}
        </p>

        {isProtected && (
          <div style={{
            background: "#F8FAFC",
            borderRadius: "16px",
            padding: "12px 20px",
            marginBottom: "24px",
            border: "1px solid #E2E8F0"
          }}>
            <span style={{ fontSize: "14px", fontWeight: "700", color: "#64748B" }}>
              Freezes left: <span style={{ color: "#0F172A" }}>{freezesLeft}</span>
            </span>
          </div>
        )}

        {!isProtected && (
          <div style={{
            background: "#F8FAFC",
            borderRadius: "20px",
            padding: "16px 20px",
            marginBottom: "24px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            border: "1px solid #E2E8F0"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px", fontWeight: "700" }}>
              <span style={{ color: "#64748B" }}>Balance:</span>
              <span style={{ color: "#0F172A" }}>{user?.coins || 0} 🪙</span>
            </div>
            {isBroken && (
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px", fontWeight: "700" }}>
                <span style={{ color: "#64748B" }}>Restore Cost:</span>
                <span style={{ color: restoreCost > (user?.coins || 0) ? "#EF4444" : "#B45309" }}>{restoreCost} 🪙</span>
              </div>
            )}
          </div>
        )}

        {isBroken && canAffordRestore && (
          <button
            style={{
              ...button,
              width: "100%",
              background: "#0F172A",
              color: "white",
              padding: "16px",
              fontSize: "17px",
              borderRadius: "18px",
              fontWeight: "800",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              boxShadow: "0 10px 15px -3px rgba(15, 23, 42, 0.2)"
            }}
            onClick={() => onRestore(missedDays, previousStreak)}
          >
            Restore Streak
          </button>
        )}

        <button
          style={{
            ...button,
            width: "100%",
            background: isProtected ? "#14B8A6" : "#F1F5F9",
            color: isProtected ? "white" : "#64748B",
            padding: isProtected ? "16px" : "12px",
            fontSize: isProtected ? "18px" : "15px",
            borderRadius: "18px",
            fontWeight: "700",
            boxShadow: isProtected 
              ? "0 10px 15px -3px rgba(20, 184, 166, 0.3)" 
              : "none",
            border: "none"
          }}
          onClick={() => setStatus(null)}
        >
          {isProtected ? "Keep it alive today 🔥" : "Start Fresh"}
        </button>
      </div>
    </div>
  );
};

export default StreakStatusModal;
